import {
  Divider,
  ListItemIcon,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as LanguageIcon } from "../../../common/icons/language.svg";

type Props = {
  selectedLanguage: string;
  handleLanguageChange: (newValue: string) => void;
};

const LanguageSelection = ({
  selectedLanguage,
  handleLanguageChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <MenuItem>
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>
        <TextField
          sx={{
            ".MuiSelect-select": {
              padding: 0,
              backgroundColor: "transparent !important",
              "& > p": {
                fontWeight: 600,
                fontFamily: '"Quicksand", sans-serif',
              },
            },
          }}
          fullWidth
          select
          variant="standard"
          size="small"
          value={selectedLanguage}
          onChange={(e) => handleLanguageChange(e.target.value)}
          InputProps={{
            disableUnderline: true,
          }}
        >
          <MenuItem value="fi">
            <Typography>{t("common:fiLong")}</Typography>
          </MenuItem>
          <MenuItem value="en">
            <Typography>{t("common:enLong")}</Typography>
          </MenuItem>
        </TextField>
      </MenuItem>
      <Divider
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.2)",
        }}
      />
    </>
  );
};

export default LanguageSelection;
